import { put, takeLatest, fork, call } from "redux-saga/effects";
import {
  ActionType,
  IPatientRegistrationResponse,
  IPatientRegistrationPayload,
} from "models/setting/patientRegistration";
import { patientRegistration } from "services/setting";
import {
  handleSuccessAction,
  handleErrorAction,
} from "./patientRegistrationActions";

function* patientRegistrationSaga({
  payload,
}: {
  payload: IPatientRegistrationPayload;
}) {
  try {
    const response: IPatientRegistrationResponse = yield call(
      patientRegistration,
      payload
    );
    yield put(handleSuccessAction(response));
  } catch (error) {
    yield put(handleErrorAction("error"));
  }
}
function* onPatientRegistrationSagaWatcher() {
  yield takeLatest(
    ActionType.PATIENT_REGISTRATION as any,
    patientRegistrationSaga
  );
}

export default [fork(onPatientRegistrationSagaWatcher)];
